<template>
    <div class="">
        <van-nav-bar style="" title="项目监控"/>
        <!--<van-row class="grid">
            <van-col span="12" >
                <div @click="routerUrl('/monitoring/customer')" >
                    <van-row><img width="28px" height="28px" src="../../assets/customer.png"/></van-row>
                    <van-row>个人客户</van-row>
                </div>
            </van-col>
            <van-col span="12">
                <div @click="routerUrl('/home/house')">
                    <van-row><img width="28px" height="28px" src="../../assets/house.png"/></van-row>
                    <van-row>房屋信息</van-row>
                </div>
            </van-col>
        </van-row>-->
        <van-row class="grid">
            <div @click="routerUrl('/monitoring/all-list')">
                <van-col span="12">
                    <van-row><img width="28px" height="28px" src="../../assets/monitoring/ic_all.png"/></van-row>
                    <van-row>全部项目</van-row>
                </van-col>
            </div>
            <div @click="routerUrl('/monitoring/audit-list')">
                <van-col span="12">
                    <van-row><img width="28px" height="28px" src="../../assets/monitoring/ic_auditing.png"/></van-row>
                    <van-row>审批中项目</van-row>
                </van-col>
            </div>
        </van-row>
        <van-row class="grid">
            <div @click="routerUrl('/monitoring/inLoan-list')">
                <van-col span="12">
                    <van-row><img width="28px" height="28px" src="../../assets/monitoring/ic_afterLoan.png"/></van-row>
                    <van-row>在贷项目</van-row>
                </van-col>
            </div>
            <div @click="routerUrl('/monitoring/clear-list')">
                <van-col span="12">
                    <van-row><img width="28px" height="28px" src="../../assets/monitoring/ic_finish.png"/></van-row>
                    <van-row>结项项目</van-row>
                </van-col>
            </div>
        </van-row>
        <van-row class="grid">
            <div @click="routerUrl('/monitoring/fail-list')">
                <van-col span="12">
                    <van-row><img width="28px" height="28px" src="../../assets/monitoring/ic_give_up.png"/></van-row>
                    <van-row>未通过项目</van-row>
                </van-col>
            </div>
            <div @click="routerUrl('/monitoring/break-list')">
                <van-col span="12">
                    <van-row><img width="28px" height="28px" src="../../assets/monitoring/ic_break.png"/></van-row>
                    <van-row>违约中项目</van-row>
                </van-col>
            </div>
        </van-row>
        <!--<van-row class="grid">
            <div v-action:Ceo @click="application">
                <van-col span="12">
                    <van-row><img width="28px" height="28px" src="../../assets/application.png"/></van-row>
                    <van-row>测试项目Ceo</van-row>
                </van-col>
            </div>
            <div v-action:Risk @click="routerUrl('/home/loan-list')">
                <van-col span="12">
                    <van-row><img width="28px" height="28px" src="../../assets/application-list.png"/></van-row>
                    <van-row>审批中项目Risk</van-row>
                </van-col>
            </div>
        </van-row>-->

    </div>
</template>

<script>
  export default {
    name: 'menus',
    components: {},
    data: function () {
      return {
      }
    },
    methods: {
      routerUrl (url) {
        this.$router.push({ path: url })
      },
      historicalTask () {
        this.$router.push({ path: '/monitoring/historical-task' })
      }
    },
    mounted() {
    }
  }
</script>

<style scoped>

</style>
